<template>
  <div v-if="value">
    <div class="cover_bg"></div>
    <div class="cover_box">
      <div class="modal_icon">
        <img
          class="modal_icon"
          src="../../../assets/components/icon_warming.png"
        />
      </div>
      <div class="title" v-show="title">{{ title }}</div>
      <div class="message">
        <slot></slot>
      </div>
      <div class="modal_footer">
        <div class="cancel_btn" @click="clickOnCancel">{{ cancelText }}</div>
        <div class="ok_btn" @click="clickOnOk">
          <van-loading size="10%" color="#ffffff" v-if="loading" />
          <span>{{ okText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    type: {
      type: String
    },
    title: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: "取消"
    },
    asyncOk: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: "确定"
    }
  },
  data() {
    return {
      loading: false
    };
  },
  watch: {
    value() {
      this.loading = false;
    }
  },
  methods: {
    clickOnOk() {
      if (this.loading) {
        return;
      }
      this.$emit("on-ok");
      if (!this.asyncOk) {
        this.$emit("input", false);
      } else {
        this.loading = true;
      }
    },
    clickOnCancel() {
      this.$emit("on-cancel");
      this.$emit("input", false);
    }
  }
};
</script>
<style lang="less" scoped>
.cover_bg {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2001;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.cover_box {
  .title {
    height: 13px;
    line-height: 13px;
    margin-bottom: 40px;
    margin-top: 20px;
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    text-align: center;
  }
  .modal_icon {
    width: 80px;
    height: 80px;
    margin: 8px auto 30px;
  }
  .message {
    margin-bottom: 10px;
    p {
      line-height: 15px;
      font-size: 9px;
      color: #333333;
    }
  }
  .modal_footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 10px;
    .cancel_btn {
      width: 108px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: solid 0.64px #e6e6e6;
      font-size: 16px;
      color: #999999;
      border-radius: 3px;
    }
    .ok_btn {
      width: 108px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #4873d3;
      font-size: 16px;
      color: #ffffff;
      border-radius: 3px;
    }
  }
  position: fixed;
  top: 45%;
  padding: 15px 13px 13px;
  left: 50%;
  width: 320px;
  overflow: hidden;
  z-index: 2002;
  background-color: #fff;
  border-radius: 4px;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
}
</style>
